interface MailLogoProps {
  fill: string;
}

/* §MAIL: іконка розділу «Пошта» — конверт. */
const MailLogo = ({ fill }: MailLogoProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 3.5h13A1.5 1.5 0 0 1 18 5v10a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 2 15V5a1.5 1.5 0 0 1 1.5-1.5Zm0 1.6v.33l6.5 4.3 6.5-4.3V5.1h-13Zm13 2.25-6.06 4a.8.8 0 0 1-.88 0L3.5 7.35v7.55h13V7.35Z"
      fill={fill}
    />
  </svg>
);

export default MailLogo;
